import { render, staticRenderFns } from "./SystemMailDetail.vue?vue&type=template&id=4205c3ce&"
import script from "./SystemMailDetail.vue?vue&type=script&lang=js&"
export * from "./SystemMailDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports